module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-15-342ff5b0bc0038ba679dd62e193b4dca.jpg";